import ApiResponseV2 from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/ApiResponseV2";
import PagedResult from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/PagedResult";
import GenericCrudServiceV2 from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/GenericCrudServiceV2";
import HttpClientV2 from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/utils/HttpClientV2";
import Holiday from "../models/Holiday";

class HolidayService extends GenericCrudServiceV2<Holiday> {
  path: string;

  constructor(path: string) {
    super(path);
    this.path = path;
  }

  findHolidaysByCountry(page: number, pageSize: number, country: string): Promise<ApiResponseV2<PagedResult<Holiday>>> {
    let url = `${this.basePath}/countries?page=${page}&pageSize=${pageSize}`;
    url += country ? "&country=" + country : "";
    return HttpClientV2.get(url);
  }

  findHolidaysOfMonthByCountry(month: number, country: String): Promise<ApiResponseV2<Holiday[]>> {
    return HttpClientV2.get(`${this.basePath}/month/${month}?country=${country}`);
  }
}

export default new HolidayService("/ensolvers-ops/holiday");
